import React, {useEffect} from "react";
import { useTranslation } from "react-i18next";

const EvalLeftInfo = ({ evalListData }) => {
	const { t } = useTranslation();

	useEffect(() => {
		console.log("evalListData-> ", evalListData)
	}, [evalListData])

	return (
		<div className="c__card left">
			<div className="img-wrap">
				<img
					src={evalListData?.round?.img}
					alt={t("pages.round.external.evaluate.list.List.img")}
				/>
			</div>
			<div className="round-info">
				<h3 className="round-title">{evalListData?.round?.title}</h3>
				<div className="info-wrap">
					<p>
						{t("pages.round.RoundList.component.EvalLeftInfo.date")} :{" "}
						{evalListData?.round?.startDate.substring(0, 10)} ~{" "}
						{evalListData?.round?.endDate.substring(0, 10)}
					</p>
					<p>
						{t("pages.round.RoundList.component.EvalLeftInfo.companyName")} :{" "}
						{evalListData?.round?.companyName}
					</p>
				</div>
				<div className="state-wrap">
					<dl className="round-state">
						<dt>{t("pages.round.RoundList.component.EvalLeftInfo.totalCompany")}</dt>
						<dd>{evalListData?.total}</dd>
					</dl>
					<dl className="evaluate-state">
						<dt>
							{t("pages.round.RoundList.component.EvalLeftInfo.reviewCompleteCount")}
						</dt>
						<dd>{evalListData?.reviewCompleteCount}</dd>
					</dl>
				</div>
			</div>
		</div>
	);
};

export default EvalLeftInfo;
